import React , { useEffect, useState , useContext }  from "react";
import AppContext from '../../shared/components/AppContext';
import { Fieldset } from 'primereact/fieldset';
import {useNavigate, useParams } from "react-router-dom";
import { StylesManager, Model } from 'survey-core';
import { useDispatch } from 'react-redux';
import { ErrorParse } from "../../shared/handlers/ErrorParse"
import RespondentService  from '../../shared/services/RespondentService';
import { onChangeLoading } from "../../redux/actions/ActionApp";
import { FormSendSurvey , InfoSurvey } from './RespondentSurveyComponent';
import { useFormik } from 'formik';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { useTranslation } from 'react-i18next';


import "../../../styles/Menu.scss";
import "./RespondentSurveyPublic.scss";


const SendCompleteSurvey = (id_survey , code , results , myContext , navigate , dispatch , SetShowFrmOtp) => {
    RespondentService.PostAnswerRespondentPublic( id_survey , code , results ).then(() => {
        myContext.notify6('success' , 'Information' , 'Survey responses saved successfully !!');
        navigate('/CompleteSurvey', { replace: true });
        if (SetShowFrmOtp !== null) {
            SetShowFrmOtp(false);
        }
    })
        .catch(error => {
            myContext.notify6('alert' , 'Error' ,  ErrorParse(error));
        }).finally(() => {
        dispatch(onChangeLoading());
    });
}

/**
 * The function is called when the survey is completed.
 */
export default function RespondentSurveyPublic() {

    const { i18n, t } = useTranslation();
    StylesManager.applyTheme("defaultV2");
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [survey , SetSurvey] = useState(() => new Model());
    const [showSurvey , SetShowSurvey] = useState(false);
    const [ showFrmOtp , SetShowFrmOtp] = useState(false);
    const [surveyInfo , SetSurveyInfo] = useState(null);
    const [txtError , SettxtError] = useState('');
    const myContext = useContext(AppContext);
    const { id_survey , code , visible } = useParams();
    const [validCode , SetValidCode] = useState(null);
    const [isPublic , SetisPublic] = useState(true);
    const [formik , SetFormik] = useState(null);


    const LogicPublic = (lg) => {
        dispatch(onChangeLoading());
        RespondentService.GetSurveyByPublicCodeAndSurveyId(id_survey , code ).then(response => {
            const jsonData = JSON.parse(response.data.content);
            jsonData.locale = lg ? lg : jsonData.locale;
            SetSurvey(() => new Model(jsonData));
            SetSurveyInfo(response.data);
            SetShowSurvey(true);
            survey.render("surveyIdResponse");
        })
            .catch(error => {
                const erro = ErrorParse(error);
                SettxtError(erro)
                myContext.notify6('alert' , 'Error' , erro);
            })
            .finally(() => {
                dispatch(onChangeLoading());
            })
    }

    useEffect(() => {
        if (visible === 'public' ) {
            LogicPublic();
        } else {
            navigate('/', { replace: true });
        }
    }, []);

    useEffect(() => {
        survey.render("surveyIdResponse");
    }, [survey]);

    const validTokenSend = () => {
        dispatch(onChangeLoading());
        const bodyRequest = { ...formik.values , "codeOtp": validCode , "content": JSON.stringify(survey.data) };
        SendCompleteSurvey(id_survey , code , bodyRequest , myContext , navigate , dispatch , SetShowFrmOtp );
    }

    const onSendSurvey = () => {
        if (survey.hasErrors(false , false) === false) {
            if (formik.dirty) {
                if (formik.isValid) {
                    dispatch(onChangeLoading());
                    RespondentService.PostOtpAnswerRespondentImported(id_survey , formik.values)
                        .then(() => {
                            SetValidCode(null);
                            SetShowFrmOtp(true);
                        })
                        .catch(error => {
                            myContext.notify6('alert' , 'Error' ,  ErrorParse(error));
                        }).finally(() => {
                        dispatch(onChangeLoading());
                    });
                } else{
                    formik.submitForm().then();
                }
            }else{
                dispatch(onChangeLoading());
                SendCompleteSurvey(id_survey , code , { "content": JSON.stringify(survey.data)  } , myContext , navigate , dispatch , null);
            }
        } else {
            survey.completeLastPage();
        }
    }

    const onCloseDialog = () => {
        if (showFrmOtp) {
            SetShowFrmOtp(false);
        }
    }

    const showSurveyRender = () => {
        return <InfoSurvey surveyInfo={surveyInfo}  survey={survey} isPublic={isPublic} setComponentChild={(name)=>LogicPublic(name)} setForm={(data) => SetFormik(data)} />
    }


    return (
        <div>
            {
                surveyInfo && surveyInfo.name ?
                    <div className="RespondentSurveyPublic context">
                        {
                            showSurvey ? showSurveyRender() : <></>
                        }
                        <Fieldset>
                            <Button label={t('RESPONDENT.SURVEY.PUBLIC.FORM.BUTTON')}  onClick={onSendSurvey} className="p-button p-button-success" />
                        </Fieldset>
                    </div>
                    :
                    <>
                        <div className="mt-6 mb-5 font-bold text-6xl text-900 text-center">{txtError}</div>
                    </>
            }
            <Dialog  visible={showFrmOtp} style={{ heigth: '50vw' }}  onHide={() => onCloseDialog()} >
                <div>
                    <span>{t('RESPONDENT.SURVEY.PUBLIC.FORM.SECTION_VERIFICATION_CODE')}</span>
                    <br></br>
                    <span>{t('RESPONDENT.SURVEY.PUBLIC.FORM.SECTION_CONFIRM_EMAIL_CODE')}</span>
                </div>
                <br></br>
                <br></br>
                <br></br>
                <div className="grid">
                    <div className="field">
                      <span className="p-float-label">
                        <InputText id="validCode" name="validCode" value={validCode} onChange={(e) => SetValidCode(e.target.value)}/>
                        <label htmlFor="validCode" >{t('RESPONDENT.SURVEY.PUBLIC.FORM.LABEL_VERIFICATION_CODE')}</label>
                      </span>
                    </div>
                    <br></br>
                    <br></br>
                    <br></br>
                    <div className="field">
                        <Button label="Verify"  onClick={() => validTokenSend()} className="p-button p-button-info" />
                    </div>
                </div>
            </Dialog>
        </div>
    );

}
